module.exports = __webpack_public_path__ + "img/close.4a8a37ae.svg";